// Startup error page modal.  Used whenever the app fails to load correctly (eg
// network error, 500).  Ask user to retry and restart app.

import { useEffect }            from 'react';
import { useState }             from 'react';
import PrimaryButton            from '../components/primary_button';
import React                    from 'react';
import renderAsPopup            from '../components/render_as_popup';
import ResourceUnavailableImage from '../assets/images/resource-unavailable.svg';
import rollbar                  from '../rollbar';


export default renderAsPopup(StartupErrorPage, 'ViewStartupErrorPage');


function StartupErrorPage({ error, retry, popup }) {
  const [ details, setDetails ] = useState(null);

  useEffect(() => {
    rollbar.error(error, (rollbarError, rollbarData) => {
      if (rollbarError) {
        // Failed to report to Rollbar, show error details
        // on screen so user can share screenshot with
        // customer support.
        setDetails(error.stack || error.message || error.toString());
      } else
        setDetails(rollbarData.result.uuid);
    });
  }, [ error ]);

  function handleOnClick(event) {
    event.preventDefault();
    popup.close();
    retry();
  }

  return (
    <div className="page-content">
      <div className="startup-error">
        <div className="startup-error__logo"/>
        <ResourceUnavailableImage className="startup-error__image"/>
        <h1>We have an error</h1>
        <div className="startup-error__cta">
          <p>Check that you have an internet connection, and try again.</p>
          <PrimaryButton label="Try Again" onClick={handleOnClick}/>
        </div>
        <div className="startup-error__error-details">
          {details}
        </div>
      </div>
    </div>
  );
}
